module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-teamcalendar__saved-views text-dark"
  }, [(_vm.itemsSelected.length > 0) ? _c('button', {
    staticClass: "bttn bttn-blue",
    on: {
      "click": _vm.setIsSaveModal
    }
  }, [_vm._v(_vm._s(_vm.i18n['save_view']) + "\n  ")]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.savedViews).length > 0) ? _c('DDropdown', {
    attrs: {
      "isShowDots": false
    }
  }, [_c('button', {
    staticClass: "d-teamcalendar__saved-views__title bttn-simple",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.i18n['saved_views']) + "\n      "), _c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.savedViews), function(view, prop) {
    return _c('li', {
      staticClass: "d-teamcalendar__saved-views__view",
      on: {
        "click": function($event) {
          return _vm.selectView(view, prop)
        }
      }
    }, [_vm._v("\n        " + _vm._s(prop) + "\n        "), _c('div', {
      staticClass: "icon__bg-circle icon__bg-circle--danger icon__bg-circle--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setDeleteItemConfirm(prop)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isSaveModal) ? _c('DModal', {
    attrs: {
      "is-bg-overlay": true,
      "show-close": false
    },
    on: {
      "close": _vm.closeIsSaveModal
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['create_new_view']))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": _vm.closeIsSaveModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['give_the_view_a_title']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    ref: "is_save_modal_input",
    staticClass: "d-input marg-1-top",
    attrs: {
      "disabled": _vm.isInputTitleDisabled,
      "placeholder": _vm.i18n['ex_title']
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveView.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (Object.keys(_vm.savedViews).length > 0) ? _c('div', {
    staticClass: "d-input-group marg-2-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['or_overwrite_existing']))]), _vm._v(" "), _c('select', {
    staticClass: "d-teamcalendar__saved-views__select",
    on: {
      "change": function($event) {
        return _vm.setReplaceExisting($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.i18n['choose_existing']))]), _vm._v(" "), _vm._l((_vm.savedViews), function(view, prop) {
    return _c('option', [_vm._v("\n              " + _vm._s(prop) + "\n            ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn bttn-simple marg-10-right",
    on: {
      "click": _vm.closeIsSaveModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), (_vm.title.length < 1) ? _c('button', {
    staticClass: "bttn submit-button submit-button--disabled"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n        ")]) : _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.saveView
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isConfirmModal) ? _c('ModalConfirmation', {
    attrs: {
      "show-close": false
    },
    on: {
      "close": function($event) {
        _vm.isConfirmModal = false
      },
      "confirm": _vm.deleteItem
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e32cb12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamCalendar/TeamCalendarHeaderSaveView.vue
// module id = 1948
// module chunks = 1